import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import env, { getEnv } from '../../../config/env'

class SentryHelper {
  init = async () => {
    Sentry.init({
      dsn: env.Sentry.dsn,
      environment: getEnv(),
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
    })
  }
}

export default new SentryHelper()
